<template>
  <div class="agent-center">
    <!-- 上部汇总信息区域 -->
    <div class="summary-section">
      <div class="summary-grid">
        <div class="summary-item">
          <div class="summary-label">代理ID</div>
          <div class="summary-value">{{ summaryData.agentId || '--' }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">合约结束日期</div>
          <div class="summary-value">{{ summaryData.agentExpire || '--' }}</div>
        </div>
        <div class="summary-item highlight-item">
          <div class="summary-label">点数池余额</div>
          <div class="summary-value highlight">{{ formatNumber(summaryData.powerPoolBalance) }}</div>
        </div>
        <div class="summary-item highlight-item">
          <div class="summary-label">未结算金额</div>
          <div class="summary-value highlight">￥{{ summaryData.unsettledAmount || '0.00' }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">用户数量</div>
          <div class="summary-value">{{ summaryData.userCount || '0' }}</div>
        </div>
        <div class="summary-item highlight-item">
          <div class="summary-label">今日用户充值</div>
          <div class="summary-value highlight">￥{{ summaryData.todayIncome || '0.00' }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">今日点数用量</div>
          <div class="summary-value">{{ formatNumber(summaryData.todayPowerUsage) || '0' }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">今日新增用户</div>
          <div class="summary-value">{{ summaryData.todayNewUsers || '0' }}</div>
        </div>
      </div>
    </div>

    <!-- 下部Tab内容区域（70%） -->
    <div class="tabs-section">
      <el-tabs v-model="activeTab" class="tabs" @tab-click="handleTabClick">
        <!-- 基础信息页面 -->
        <el-tab-pane label="基础信息" name="basic">
          <div class="tab-content">
            <el-form :model="basicInfoForm" :rules="basicInfoRules" ref="basicInfoFormRef" label-width="120px" class="form-width">
              <el-form-item label="网址" prop="website">
                <el-text >https://www.elemagix.com/home?agent={{ summaryData.agentId }}</el-text>
                <el-button type="info" link size="small" @click="copyWebsite" style="margin-left: 10px;">
                  <el-icon><CopyDocument /></el-icon>
                  复制
                </el-button>
              </el-form-item>
              <el-form-item label="网站标题" prop="siteTitle">
                <el-input v-model="basicInfoForm.siteTitle" placeholder="请输入网站标题" maxlength="15" show-word-limit/>
              </el-form-item>
              <el-form-item label="网站副标题" prop="siteSubtitle">
                <el-input v-model="basicInfoForm.siteSubtitle" placeholder="请输入网站副标题" maxlength="30" show-word-limit />
              </el-form-item>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Logo" prop="logo">
                    <el-upload
                      action="#"
                      :show-file-list="false"
                      :on-change="handleLogoChange"
                      :auto-upload="false"
                      accept="image/*"
                    >
                      <div class="image-uploader">
                        <img v-if="basicInfoForm.logo" :src="basicInfoForm.logo" class="uploaded-image" />
                        <el-icon v-else class="upload-icon"><Plus /></el-icon>
                        <div v-if="!basicInfoForm.logo" class="upload-text">点击上传Logo</div>
                      </div>
                    </el-upload>
                    <el-text style="font-size: 12px;margin-left: 10px; color: #999;">建议尺寸500*500</el-text>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客服二维码" prop="customerServiceQrCode">
                    <el-upload
                      action="#"
                      :show-file-list="false"
                      :on-change="handleCustomerServiceQrChange"
                      :auto-upload="false"
                      accept="image/*"
                    >
                      <div class="image-uploader2">
                        <img v-if="basicInfoForm.customerServiceQrCode" :src="basicInfoForm.customerServiceQrCode" class="uploaded-image" />
                        <el-icon v-else class="upload-icon"><Plus /></el-icon>
                        <div v-if="!basicInfoForm.customerServiceQrCode" class="upload-text">点击上传客服二维码</div>
                      </div>
                    </el-upload>
                    <el-text style="font-size: 12px;margin-left: 10px; color: #999;">建议尺寸1080*1470</el-text>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button type="primary" @click="saveBasicInfo">保存修改</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 邀请码页面 -->
        <el-tab-pane label="邀请码" name="invite" style="height: 100%; ">
          <div class="tab-content">
            
            <div class="section-title-row" >
              <div class="section-title">
                邀请码列表
                <div style="font-size: 12px; color: #999;">
                  （已用{{ inviteCodeList.filter(item => item.status === 'used' || Number(item.availQty) === 0).length }}个/共{{ inviteCodeList.length }}个）
                </div>
              </div>
              <div class="filter-bar">
                <el-select v-model="inviteFilterStatus" placeholder="状态" size="default" style="width: 120px;">
                  <el-option label="全部" value="" />
                  <el-option label="未使用" value="unused" />
                  <el-option label="已使用" value="used" />
                  <el-option label="禁用" value="disabled" />
                </el-select>
                <el-date-picker
                  v-model="inviteFilterDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  size="default"
                  style="margin: 0 8px; width: 240px;"
                />
                <el-button type="info" size="default" @click="onInviteSearch">搜索</el-button>
              </div>
            </div>
            <div class="table-scroll-area">
              <el-table :data="inviteCodeList" height="100%" stripe>
                <el-table-column prop="inviteCode" label="邀请码" min-width="180" />
                <el-table-column prop="status" label="状态" min-width="100">
                  <template #default="{ row }">
                    <el-tag :type="getStatusTagType(row.status)">
                      {{ getStatusText(row.status) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="availQty" label="可用次数" min-width="100" />
                <el-table-column prop="createDate" label="创建日期" min-width="150" />
                <el-table-column prop="remark" label="备注" min-width="120" />
                <el-table-column label="操作" min-width="150" fixed="right">
                  <template #default="{ row }">
                    <el-button type="primary" link size="small" @click="copyInviteCode(row)">
                      <el-icon><DocumentCopy /></el-icon>
                      复制
                    </el-button>
                    <el-button 
                      v-if="row.status !== 'disabled'" 
                      type="danger" 
                      link 
                      size="small" 
                      @click="toggleInviteCodeStatus(row, 'disabled')"
                    >
                      <el-icon><CircleCloseFilled /></el-icon>
                      禁用
                    </el-button>
                    <el-button 
                      v-if="row.status === 'disabled'" 
                      type="success" 
                      link 
                      size="small" 
                      @click="toggleInviteCodeStatus(row, 'active')"
                    >
                      <el-icon><SuccessFilled /></el-icon>
                      激活
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <Pagination
              v-if="inviteTotal > 0"
              :total="inviteTotal"
              :current-page="invitePage"
              :page-size="inviteLimit"
              :page-sizes="[20, 50, 100]"
              @page-change="handleInvitePageChange"
              @size-change="handleInviteSizeChange"
            />
          </div>
        </el-tab-pane>

        <!-- 点数流水页面 -->
        <el-tab-pane label="点数管理" name="power">
          <div class="tab-content">
            <!-- 点数池余额和增加额度按钮 -->
            <div class="power-balance-row">
              <div class="power-balance-info">
                <span class="power-balance-label">点数池余额：</span>
                <span class="power-balance-value">{{ formatNumber(summaryData.powerPoolBalance) }}</span>
              </div>
              <el-button type="primary" size="default" @click="blockUnavailablePayment">增加额度</el-button>
              <el-button type="success" size="default" @click="showTransferDialog = true">转移点数</el-button>
            </div>
            <div class="section-title-row">
              <div class="section-title">点数流水</div>
              <div class="filter-bar">
                <el-select v-model="powerFilterType" placeholder="业务类型" size="default" style="width: 120px;">
                  <el-option label="全部" value="" />
                  <el-option label="充值" value="1" />
                  <el-option label="消费" value="2" />
                  <el-option label="赠送" value="3" />
                  <el-option label="退款" value="4" />
                </el-select>
                <el-date-picker
                  v-model="powerFilterDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  size="default"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  style="margin: 0 8px; width: 240px;"
                />
                <el-button type="info" size="default" @click="onPowerSearch">搜索</el-button>
              </div>
            </div>
            <div class="table-scroll-area">
              <el-table :data="powerLogList" height="100%" stripe>
                <el-table-column prop="appName" label="应用名称" min-width="140" />
                <el-table-column prop="serialNum" label="流水号" min-width="180" />
                <el-table-column prop="userName" label="用户名称" min-width="120" />
                <el-table-column prop="changeTime" label="创建时间" min-width="150" />
                <el-table-column prop="type" label="业务类型" min-width="100">
                  <template #default="{ row }">
                    {{ getChangeTypeText(row.changeType) }}
                  </template>
                </el-table-column>
                <el-table-column prop="poolDeduction" label="点数池变动" min-width="150">
                  <template #default="{ row }">
                    <span v-if="row.poolDeduction === '--'" class="text-muted">{{ row.poolDeduction }}</span>
                    <span v-else :class="{'text-success': row.poolDeduction && row.poolDeduction.startsWith('+'), 'text-danger': row.poolDeduction && row.poolDeduction.startsWith('-')}">{{ row.poolDeduction }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="poolBalance" label="点数池余额" min-width="150">
                  <template #default="{ row }">
                    <span class="text-highlight">{{ row.poolBalance || '--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="changeAmount" label="用户点数变动" min-width="100" >
                  <template #default="{ row }">
                    <span :class="{'text-success': row.changeAmount && row.changeAmount.startsWith('+'), 'text-danger': row.changeAmount && row.changeAmount.startsWith('-')}">{{ row.changeAmount }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="userBalance" label="变动后余额" min-width="110">
                  <template #default="{ row }">
                    {{ row.userBalance }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <Pagination
              v-if="powerTotal > 0"
              :total="powerTotal"
              :current-page="powerPage"
              :page-size="powerLimit"
              :page-sizes="[20, 50, 100]"
              @page-change="handlePowerPageChange"
              @size-change="handlePowerSizeChange"
            />
          </div>
        </el-tab-pane>

        <!-- 结算对账页面 -->
        <el-tab-pane label="结算对账" name="withdraw">
          <div class="tab-content">
            <div class="section-title-row">
              <div class="section-title">结算对账</div>
              
              <div class="withdraw-amount-info">
                <span class="withdraw-label">未结算金额：</span>
                <span class="withdraw-value">￥{{ unsettledAmount || '0.00' }}</span>
              </div>
            </div>
            <div class="table-scroll-area">
              <el-table :data="withdrawList" height="100%" stripe>
                <el-table-column prop="withdrawDate" label="结算日期" min-width="150" />
                <el-table-column prop="userRechargePowerSum" label="用户充值总点数" min-width="150">
                  <template #default="{ row }">
                    <span class="text-highlight">{{ row.userRechargePowerSum || '0' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="poolDeductionSum" label="点数池扣减" min-width="150">
                  <template #default="{ row }">
                    <span class="text-danger">{{ row.poolDeductionSum || '0' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="poolOverflowSum" label="点数池溢出" min-width="150">
                  <template #default="{ row }">
                    <span class="text-success">{{ row.poolOverflowSum || '0' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="billAmount" label="用户充值总金额" min-width="120">
                  <template #default="{ row }">
                    ￥{{ row.billAmount || '0.00' }}
                  </template>
                </el-table-column>
                <el-table-column prop="serviceFee" label="服务费扣减" min-width="120">
                  <template #default="{ row }">
                    ￥{{ row.serviceFee || '0.00' }}
                  </template>
                </el-table-column>
                <el-table-column prop="actualAmount" label="实收金额" min-width="120">
                  <template #default="{ row }">
                    <span class="highlight">￥{{ row.actualAmount || '0.00' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" min-width="100">
                  <template #default="{ row }">
                    <el-tag :type="getWithdrawStatusTagType(row.status)">
                      {{ getWithdrawStatusText(row.status) }}
                    </el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <Pagination
              v-if="withdrawTotal > 0"
              :total="withdrawTotal"
              :current-page="withdrawPage"
              :page-size="withdrawLimit"
              :page-sizes="[20, 50, 100]"
              @page-change="handleWithdrawPageChange"
              @size-change="handleWithdrawSizeChange"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 点数转移对话框 -->
    <el-dialog
      v-model="showTransferDialog"
      title="点数转移"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <div class="transfer-content">
        <div class="transfer-info">
          <div class="transfer-info-item">
            <span class="transfer-info-label">当前点数池余额：</span>
            <span class="transfer-info-value">{{ formatNumber(summaryData.powerPoolBalance) }}</span>
          </div>
        </div>
        <el-form :model="transferForm" :rules="transferRules" ref="transferFormRef" label-width="120px" style="margin-top: 24px;">
          
          <el-form-item label="转移点数" prop="power">
            <el-input-number 
              v-model="transferForm.power" 
              :min="1" 
              :max="parseFloat(summaryData.powerPoolBalance) || 0"
              :precision="0"
              :step="1000"
              style="width: 220px;"
              />
            
            <div style="font-size: 12px; color: #999; margin-left: 8px;">
              最多可转移：{{ formatNumber(summaryData.powerPoolBalance) }}
            </div>
          </el-form-item>
          <el-form-item label="转移至" prop="toUserId">
            <el-select v-model="transferForm.toUserId" placeholder="请选择接收用户" filterable style="width: 100%;" @focus="loadSubUserList">
              <el-option
                v-for="user in subUserList"
                :key="user.id"
                :label="user.name + (user.accountNo ? ' (' + user.accountNo + ')' : '')"
                :value="user.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注说明" prop="remark">
            <el-input 
              v-model="transferForm.remark" 
              type="textarea" 
              :rows="3" 
              placeholder="请输入转移说明（可选）"
              maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <el-button @click="showTransferDialog = false">取消</el-button>
        <el-button 
          type="primary" 
          @click="handleTransferConfirm" 
          :loading="transferLoading"
          :disabled="!transferForm.toUserId || !transferForm.power || transferForm.power <= 0"
        >
          确认转移
        </el-button>
      </template>
    </el-dialog>

    <!-- 点数充值对话框 -->
    <el-dialog
      v-model="showRechargeDialog"
      title="点数池充值"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <div class="recharge-content">
        <div class="recharge-cards">
          <div
            v-for="card in rechargeCards"
            :key="card.id"
            class="recharge-card"
            :class="{ selected: !isCustom && selectedRechargeCard?.id === card.id }"
            @click="selectRechargeCard(card)"
          >
            <div v-if="card.remark" class="recharge-discount-badge">{{ card.remark }}</div>
            <div class="recharge-power">{{ formatNumber(card.actPower) }}<span v-if="card.giveMoney" class="gift">+{{ formatNumber(card.power * (card.giveMoney/10)) }}</span></div>
            <div class="recharge-price">￥{{ card.price }}</div>
            <div v-if="card.giveMoney" class="gift2">额外赠送 {{ card.giveMoney }}%</div>
          </div>
        </div>
        <div class="custom-recharge" style="margin-top: 24px;" v-if="rechargeCards.length === 0">
          <el-checkbox v-model="isCustom" @change="selectedRechargeCard=null"></el-checkbox>
          <el-input-number 
            v-model="customAmount.value" 
            :min="20" 
            :max="100000" 
            label="自定义充值"
            style="margin-left: 12px;"
            :disabled="!isCustom"
          >
            <template #suffix>
              <span>W</span>
            </template>
          </el-input-number>
          <el-text class="power-price" style="margin-left: 12px;">￥{{ customAmount.price }}</el-text>
          <span class="custom-recharge-tip">自定义充值：输入点数数量自动计算金额</span>
        </div>
        <div class="recharge-pay-method" style="margin-top: 24px;">
          <div class="pay-method-label">支付方式：</div>
          <el-radio-group v-model="rechargePayMethod" style="margin-top: 12px;">
            <el-radio label="wechat">微信</el-radio>
            <el-radio label="alipay">支付宝</el-radio>
          </el-radio-group>
        </div>
      </div>
      <template #footer>
        <el-button @click="showRechargeDialog = false">取消</el-button>
        <el-button 
          type="primary" 
          @click="handleRechargeConfirm" 
          :disabled="rechargeCards.length > 0 ? !selectedRechargeCard : (!isCustom || customAmount.value <= 0)"
        >
          确认充值
        </el-button>
      </template>
    </el-dialog>

    <!-- 支付对话框 -->
    <el-dialog
      v-model="showPayModal"
      title="扫码支付"
      width="480px"
      :close-on-click-modal="false"
      :show-close="true"
      center
    >
      <div class="pay-modal">
        <div class="pay-order">
          <img
            v-if="rechargePayMethod === 'wechat' && payQRCode"
            :src="payQRCode"
            alt="微信二维码"
            class="pay-qrcode"
          />
          <div v-if="rechargePayMethod === 'wechat'">
            <div class="pay-info">
              <div>订单编号：{{ currentOrderId }}</div>
              <div>点数值到账：{{ isCustom ? customAmount.value : (selectedRechargeCard?.power || 0) }}w（永久）</div>
              <div>支付方式：微信</div>
              <div class="pay-amount">订单金额：<span class="pay-amount-value">￥{{ isCustom ? customAmount.price : (selectedRechargeCard?.price || 0) }}</span></div>
            </div>
          </div>
        </div>
        <div class="pay-tip" v-if="rechargePayMethod === 'wechat'">【温馨提示】：点数值为平台虚拟商品，购买后不可退款。</div>
      </div>
    </el-dialog>
    <PaymentUnavailableDialog v-model="showPaymentUnavailable" />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, reactive, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Plus, DocumentCopy, CircleCloseFilled, SuccessFilled } from '@element-plus/icons-vue'
import { uploadImage, saveAgentBasicInfo, getAgentInviteCodeList, getAgentPowerLogList, getAgentSummary, getUserInfo, getCreditCalculationList, getSubUserList, transferPowerPool, updateInviteCodeRemark } from '@/api/portal/user'
import { getRechargePackageList } from '@/api/portal/mall'
import { createAgentPowerPoolOrder, getWxPayParams, getAlipayParams, queryWxPayOrder, queryAlipayOrder } from '@/api/portal/order'
import QRCode from 'qrcode'
import Pagination from '@/apps/portal/components/Pagination.vue'
import PaymentUnavailableDialog from '@/apps/portal/components/PaymentUnavailableDialog.vue'
import { formatUserPowerBalance, formatUserPowerChange } from './agentPowerLog'
// import { getAgentSummary, getAgentBasicInfo, updateAgentBasicInfo, getInviteCodeList, toggleInviteCode, getAgentPowerLogList, getWithdrawList, applyWithdraw } from '@/api/agent'

// Tab切换
const activeTab = ref('basic')
const showPaymentUnavailable = ref(false)

function blockUnavailablePayment() {
  showPaymentUnavailable.value = true
  return true
}

function handleTabClick(tab) {
  console.log(tab)
}

// 格式化数字，添加千位分隔符
const formatNumber = (num) => {
  if (num === null || num === undefined || num === '') {
    return '0'
  }
  const numStr = String(num)
  // 如果是数字字符串，转换为数字再格式化
  const number = parseFloat(numStr)
  if (isNaN(number)) {
    return numStr
  }
  // 使用 toLocaleString 添加千位分隔符
  return number.toLocaleString('zh-CN')
}

// 汇总数据
const summaryData = ref({
  agentId: '',
  agentExpire: '',
  powerPoolBalance: 0,
  unsettledAmount: 0,
  userCount: 0,
  todayIncome: 0,
  todayPowerUsage: 0,
  todayNewUsers: 0
})

// 获取汇总数据
const getSummaryData = async () => {
  try {
    // 从 localStorage 获取用户信息
    const userInfoStr = localStorage.getItem('userInfo')
    if (userInfoStr) {
      try {
        const userInfo = JSON.parse(userInfoStr)
        
        // 从 userInfo 中读取代理相关字段
        const agentId = userInfo.agentId || ''
        const agentExpire = userInfo.agentExpire || ''
        const agentPowerPool = userInfo.agentPowerPool ? parseFloat(userInfo.agentPowerPool) : 0
        const agentUsedPower = userInfo.agentUsedPower ? parseFloat(userInfo.agentUsedPower) : 0
        
        // 计算点数池余额 = 点数池 - 已使用点数
        const powerPoolBalance = Math.max(0, agentPowerPool - agentUsedPower)
        
        // 更新汇总数据
        summaryData.value = {
          ...summaryData.value,
          agentId: agentId,
          agentExpire: agentExpire,
          powerPoolBalance: powerPoolBalance
        }
        
        console.log('汇总数据已更新:', {
          agentId,
          agentExpire,
          powerPoolBalance,
          agentPowerPool,
          agentUsedPower
        })
      } catch (parseError) {
        console.error('解析用户信息失败:', parseError)
      }
    } else {
      console.warn('localStorage 中没有用户信息')
    }
    
    // 从接口获取用户数量、今日新增用户数量、今日点数用量、今日用户充值和未结算金额
    try {
      const res = await getAgentSummary()
      if (res && res.code === 0 && res.data) {
        summaryData.value = {
          ...summaryData.value,
          userCount: res.data.userCount || 0,
          todayNewUsers: res.data.todayNewUsers || 0,
          todayPowerUsage: res.data.todayPowerUsage ? parseFloat(res.data.todayPowerUsage) : 0,
          todayIncome: res.data.todayIncome ? parseFloat(res.data.todayIncome) : 0,
          unsettledAmount: res.data.unsettledAmount ? parseFloat(res.data.unsettledAmount) : 0
        }
      } else {
        // 如果接口调用失败，使用默认值（不显示错误，因为响应拦截器已经显示了）
        summaryData.value = {
          ...summaryData.value,
          userCount: 0,
          todayNewUsers: 0,
          todayPowerUsage: 0,
          todayIncome: 0,
          unsettledAmount: 0
        }
      }
    } catch (error) {
      // 接口调用异常，使用默认值（响应拦截器已经显示了错误消息）
      console.error('获取汇总数据异常:', error)
      summaryData.value = {
        ...summaryData.value,
        userCount: 0,
        todayNewUsers: 0,
        todayPowerUsage: 0,
        todayIncome: 0,
        unsettledAmount: 0
      }
    }
  } catch (error) {
    // 响应拦截器已经显示了错误消息，这里只记录日志
    console.error('获取汇总数据失败:', error)
    // 设置默认值
    summaryData.value = {
      ...summaryData.value,
      userCount: 0,
      todayNewUsers: 0,
      todayPowerUsage: 0,
      unsettledAmount: 0,
      todayIncome: 0
    }
  }
}

// 基础信息表单
const basicInfoForm = ref({
  website: '',
  siteTitle: '',
  siteSubtitle: '',
  logo: '',
  coverImage: '',
  customerServiceQrCode: ''
})
const basicInfoFormRef = ref()
const basicInfoRules = {
  website: [{ required: true, message: '请输入网址', trigger: 'blur' }],
  siteTitle: [{ required: true, message: '请输入网站标题', trigger: 'blur' }]
}

// 获取基础信息
const getBasicInfo = async () => {
  try {
    // 从 localStorage 获取用户信息
    const userInfoStr = localStorage.getItem('userInfo')
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr)
      // 从用户信息中读取基础信息字段
      basicInfoForm.value = {
        website: userInfo.agentSiteUrl || '',
        siteTitle: userInfo.agentSiteTitle || '',
        siteSubtitle: userInfo.agentSiteSubtitle || '',
        logo: userInfo.agentSiteLogo || '',
        coverImage: userInfo.agentSitePic || '',
        customerServiceQrCode: userInfo.agentSiteQrcode || ''
      }
    } else {
      // 如果没有用户信息，尝试从接口获取
      try {
        const res = await getUserInfo()
        if (res && res.code === 0) {
          // 处理不同的返回格式
          const userInfo = res.data?.userInfo || res.userInfo
          if (userInfo) {
            basicInfoForm.value = {
              website: userInfo.agentSiteUrl || '',
              siteTitle: userInfo.agentSiteTitle || '',
              siteSubtitle: userInfo.agentSiteSubtitle || '',
              logo: userInfo.agentSiteLogo || '',
              coverImage: userInfo.agentSitePic || '',
              customerServiceQrCode: userInfo.agentSiteQrcode || ''
            }
          }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    }
  } catch (error) {
    console.error('获取基础信息失败:', error)
  }
}

// Logo上传
const handleLogoChange = async (file) => {
  try {
    const formData = new FormData()
    formData.append('file', file.raw)
    const res = await uploadImage(formData)
    if (res.code === 0) {
      basicInfoForm.value.logo = res.url
      ElMessage.success('Logo上传成功')
    } else {
      ElMessage.error(res.msg || 'Logo上传失败')
    }
  } catch (error) {
    ElMessage.error('Logo上传失败')
    console.error('Logo上传失败:', error)
  }
}

// 封面图上传
const handleCoverChange = async (file) => {
  try {
    const formData = new FormData()
    formData.append('file', file.raw)
    const res = await uploadImage(formData)
    if (res.code === 0) {
      basicInfoForm.value.coverImage = res.url
      ElMessage.success('封面图上传成功')
    } else {
      ElMessage.error(res.msg || '封面图上传失败')
    }
  } catch (error) {
    ElMessage.error('封面图上传失败')
    console.error('封面图上传失败:', error)
  }
}

// 客服二维码上传
const handleCustomerServiceQrChange = async (file) => {
  try {
    const formData = new FormData()
    formData.append('file', file.raw)
    const res = await uploadImage(formData)
    if (res.code === 0) {
      basicInfoForm.value.customerServiceQrCode = res.url
      ElMessage.success('客服二维码上传成功')
    } else {
      ElMessage.error(res.msg || '客服二维码上传失败')
    }
  } catch (error) {
    ElMessage.error('客服二维码上传失败')
    console.error('客服二维码上传失败:', error)
  }
}

// 保存基础信息
const saveBasicInfo = async () => {
  try {
    basicInfoFormRef.value.validate(async (valid) => {
      if (valid) {
        try {
          const res = await saveAgentBasicInfo({
            website: basicInfoForm.value.website,
            siteTitle: basicInfoForm.value.siteTitle,
            siteSubtitle: basicInfoForm.value.siteSubtitle,
            logo: basicInfoForm.value.logo,
            coverImage: basicInfoForm.value.coverImage,
            customerServiceQrCode: basicInfoForm.value.customerServiceQrCode
          })
          if (res && res.code === 0) {
            ElMessage.success('保存成功')
            // 保存成功后，重新获取用户信息并更新 localStorage
            await refreshUserInfo(true)
          } else {
            ElMessage.error(res?.msg || '保存失败')
          }
        } catch (error) {
          console.error('保存基础信息异常:', error)
          // 响应拦截器已经显示了错误消息
        }
      }
    })
  } catch (error) {
    console.error('表单验证失败:', error)
  }
}

// 复制网址
const copyWebsite = () => {
  navigator.clipboard.writeText('https://www.elemagix.com/home?agent=' + summaryData.value.agentId).then(() => {
    ElMessage.success('网址已复制到剪贴板')
  }).catch(() => {
    ElMessage.error('复制失败')
  })
}
// 刷新用户信息
const refreshUserInfo = async (updateSummary = true) => {
  try {
    const res = await getUserInfo()
    if (res && res.code === 0) {
      // 处理不同的返回格式：可能是 res.data.userInfo 或 res.userInfo
      const userInfo = res.data?.userInfo || res.userInfo
      if (userInfo) {
        // 更新 localStorage 中的用户信息
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
        //console.log('用户信息已更新:', userInfo)
        
        // 更新基础信息表单
        basicInfoForm.value = {
          website: userInfo.agentSiteUrl || '',
          siteTitle: userInfo.agentSiteTitle || '',
          siteSubtitle: userInfo.agentSiteSubtitle || '',
          logo: userInfo.agentSiteLogo || '',
          coverImage: userInfo.agentSitePic || '',
          customerServiceQrCode: userInfo.agentSiteQrcode || ''
        }
        
        // 如果需要更新汇总数据（因为用户信息已更新）
        if (updateSummary) {
          // 直接更新汇总数据中的代理相关字段
          summaryData.value = {
            ...summaryData.value,
            agentId: userInfo.agentId || '',
            agentExpire: userInfo.agentExpire || '',
            powerPoolBalance: Math.max(0, (userInfo.agentPowerPool ? parseFloat(userInfo.agentPowerPool) : 0) - (userInfo.agentUsedPower ? parseFloat(userInfo.agentUsedPower) : 0))
          }
          // 然后获取其他汇总数据
          await getSummaryData()
        }
      } else {
        console.warn('用户信息为空:', res)
      }
    } else {
      console.warn('获取用户信息失败:', res)
    }
  } catch (error) {
    console.error('刷新用户信息失败:', error)
  }
}

// 邀请码相关
const inviteCodeList = ref([])
const invitePage = ref(1)
const inviteLimit = ref(20)
const inviteTotal = ref(0)
const inviteFilterStatus = ref('')
const inviteFilterDateRange = ref([])

// 获取邀请码列表
const getInviteCodeList = async () => {
  try {
    const params = {
      page: invitePage.value,
      limit: inviteLimit.value
    }
    
    // 状态筛选：将前端的状态值转换为后端的状态值
    if (inviteFilterStatus.value) {
      if (inviteFilterStatus.value === 'unused') {
        params.status = 1 // 正常状态
      } else if (inviteFilterStatus.value === 'used') {
        // 已使用需要通过其他方式判断，这里先不处理
      } else if (inviteFilterStatus.value === 'disabled') {
        params.status = 0 // 停用状态
      }
    }
    
    // 日期范围筛选
    if (inviteFilterDateRange.value && inviteFilterDateRange.value.length === 2) {
      params.startDate = inviteFilterDateRange.value[0]
      params.endDate = inviteFilterDateRange.value[1]
    }
    
    const res = await getAgentInviteCodeList(params)
    //console.log('邀请码列表接口返回:', res)
    if (res && res.code === 0) {
      // 处理不同的返回格式
      const data = res.data || res
      const list = data.list || []
      const total = data.total || 0
      
      //console.log('邀请码列表数据:', { list, total })
      
      // 转换数据格式，适配前端显示
      inviteCodeList.value = list.map(item => {
        // 后端字段可能是字符串（如 '0'），这里统一转成数字用于状态判断
        const statusNum = Number(item.status)
        const availQtyNum = Number(item.availQty)
        const safeAvailQty = Number.isFinite(availQtyNum) ? availQtyNum : 0

        return {
          id: item.id,
          inviteCode: item.inviteCode,
          status: statusNum === 0 ? 'disabled' : (safeAvailQty <= 0 ? 'used' : 'unused'),
          createDate: item.createDate ? new Date(item.createDate).toLocaleDateString('zh-CN') : '--',
          availQty: safeAvailQty,
          remark: item.remark || ''
        }
      })
      inviteTotal.value = total
    } else {
      // 响应拦截器已经显示了错误消息
      console.warn('获取邀请码列表失败:', res)
      inviteCodeList.value = []
      inviteTotal.value = 0
    }
  } catch (error) {
    // 响应拦截器已经显示了错误消息，这里只记录日志
    console.error('获取邀请码列表失败:', error)
    inviteCodeList.value = []
    inviteTotal.value = 0
  }
}



// 复制邀请码
const copyInviteCode = async (row) => {
  try {
    // 弹窗输入备注
    const { value } = await ElMessageBox.prompt('请输入备注信息', '复制邀请码', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputValue: row.remark || '',
      inputPlaceholder: '请输入备注信息（可选）',
      inputType: 'textarea',
      inputValidator: (value) => {
        // 备注可以为空，但如果有值，长度不能超过200
        if (value && value.length > 200) {
          return '备注长度不能超过200个字符'
        }
        return true
      }
    })

    // 如果输入了备注，更新备注
    if (value !== null && value !== undefined) {
      try {
        const res = await updateInviteCodeRemark({
          inviteCode: row.inviteCode,
          remark: value
        })
        if (res && res.code === 0) {
          // 更新本地数据
          row.remark = value
          ElMessage.success('备注已更新')
        } else {
          ElMessage.error(res?.msg || '更新备注失败')
        }
      } catch (error) {
        console.error('更新备注失败:', error)
        ElMessage.error('更新备注失败')
      }
    }

    // 复制邀请码到剪贴板
    navigator.clipboard.writeText(row.inviteCode).then(() => {
      ElMessage.success('邀请码已复制到剪贴板')
    }).catch(() => {
      ElMessage.error('复制失败')
    })
  } catch (error) {
    // 用户取消输入，仍然复制邀请码
    if (error !== 'cancel') {
      navigator.clipboard.writeText(row.inviteCode).then(() => {
        ElMessage.success('邀请码已复制到剪贴板')
      }).catch(() => {
        ElMessage.error('复制失败')
      })
    }
  }
}

// 切换邀请码状态
const toggleInviteCodeStatus = async (row, status) => {
  try {
    // await toggleInviteCode({ id: row.id, status })
    row.status = status === 'disabled' ? 'disabled' : (row.status === 'used' ? 'used' : 'unused')
    ElMessage.success(status === 'disabled' ? '已禁用' : '已激活')
  } catch (error) {
    ElMessage.error('操作失败')
  }
}

// 获取状态文本
const getStatusText = (status) => {
  const statusMap = {
    disabled: '禁用',
    unused: '未使用',
    used: '已使用'
  }
  return statusMap[status] || '未知'
}

// 获取状态标签类型
const getStatusTagType = (status) => {
  const typeMap = {
    disabled: 'danger',
    unused: 'info',
    used: 'success'
  }
  return typeMap[status] || ''
}

// 邀请码搜索
const onInviteSearch = () => {
  invitePage.value = 1
  getInviteCodeList()
}

// 邀请码分页
const handleInvitePageChange = (val) => {
  invitePage.value = val
  getInviteCodeList()
}

const handleInviteSizeChange = (val) => {
  inviteLimit.value = val
  invitePage.value = 1
  getInviteCodeList()
}

// 点数流水相关
const powerLogList = ref([])
const powerPage = ref(1)
const powerLimit = ref(20)
const powerTotal = ref(0)
const powerFilterType = ref('')
const powerFilterDateRange = ref([])

// 获取点数流水列表
const getPowerLogList = async () => {
  try {
    const params = {
      page: powerPage.value,
      limit: powerLimit.value
    }
    
    // 业务类型筛选
    if (powerFilterType.value) {
      params.changeType = parseInt(powerFilterType.value)
    }
    
    // 日期范围筛选
    if (powerFilterDateRange.value && powerFilterDateRange.value.length === 2) {
      params.startTime = powerFilterDateRange.value[0]
      params.endTime = powerFilterDateRange.value[1]
    }
    
    const res = await getAgentPowerLogList(params)
    if (res && res.code === 0 && res.page) {
      // 转换数据格式，适配前端显示
      powerLogList.value = (res.page.list || []).map(item => {
        // 计算点数池扣减和余额
        let poolDeduction = '--'
        let poolBalance = '--'
        
        if (item.agentTotalPower != null && item.agentBalancePower != null) {
          // 点数池扣减 = 扣减前的可用点数 - 扣减后的可用点数
          const agentTotal = parseFloat(item.agentTotalPower) || 0
          const agentBalance = parseFloat(item.agentBalancePower) || 0
          const deduction = agentTotal - agentBalance
          
          if (deduction !== 0) {
            // 如果扣减前大于扣减后，说明扣减了，显示负数
            // 如果扣减前小于扣减后，说明增加了，显示正数
            poolDeduction = deduction > 0 ? '-' + deduction : '+' + Math.abs(deduction)
          } else {
            poolDeduction = '0'
          }
          // 点数池余额 = 扣减后的可用点数
          poolBalance = agentBalance
        } else if (item.agentBalancePower != null) {
          // 如果只有余额，只显示余额
          const agentBalance = parseFloat(item.agentBalancePower) || 0
          poolBalance = agentBalance
        }
        
        return {
          id: item.id,
          appName: item.appName || item.changeDesc || '其他应用',
          serialNum: item.serialNum || '--',
          userName: item.userName || '--',
          changeTime: item.changeTime ? new Date(item.changeTime).toLocaleString('zh-CN') : '--',
          changeType: item.changeType,
          couponType: item.couponType,
          changeAmount: formatUserPowerChange(item),
          userBalance: formatUserPowerBalance(item),
          changeDesc: item.changeDesc || '',
          remark: item.remark || '',
          poolDeduction: poolDeduction,
          poolBalance: poolBalance
        }
      })
      powerTotal.value = res.page.total || 0
    } else {
      // 响应拦截器已经显示了错误消息
      powerLogList.value = []
      powerTotal.value = 0
    }
  } catch (error) {
    // 响应拦截器已经显示了错误消息，这里只记录日志
    console.error('获取点数流水失败:', error)
    powerLogList.value = []
    powerTotal.value = 0
  }
}

// 业务类型转换
const getChangeTypeText = (type) => {
  const typeMap = {
    1: '充值',
    2: '消费',
    3: '赠送',
    4: '退款',
    5: '转移'
  }
  return typeMap[type] || '未知'
}

// 点数流水搜索
const onPowerSearch = () => {
  powerPage.value = 1
  getPowerLogList()
}

// 点数流水分页
const handlePowerPageChange = (val) => {
  powerPage.value = val
  getPowerLogList()
}

const handlePowerSizeChange = (val) => {
  powerLimit.value = val
  powerPage.value = 1
  getPowerLogList()
}

// 点数充值相关
const showRechargeDialog = ref(false)
const showPayModal = ref(false)
const selectedRechargeCard = ref(null)
const rechargePayMethod = ref('wechat')
const rechargeCards = ref([])
const payQRCode = ref('')
const currentOrderId = ref('')
const paymentPollingTimer = ref(null)
const isCustom = ref(false)
const customAmount = reactive({
  value: 0,
  price: 0
})

// 获取充值套餐列表（只显示代理商充值套餐 recType = 1）
const getRechargeCards = async () => {
  try {
    const res = await getRechargePackageList()
    if (res.code === 0) {
      // 过滤出 recType = 1 的套餐（代理商充值套餐）
      rechargeCards.value = (res.list || [])
        .filter(item => item.recType === 1)
        .map(item => ({
          id: item.id,
          power: item.packageName,
          price: item.rechargeMoney,
          actPower: item.actPower,
          giveMoney: item.giveMoney,
          remark: item.remark
        }))
    }
  } catch (error) {
    console.error('获取充值套餐失败:', error)
    rechargeCards.value = []
  }
}

// 选择充值卡片
const selectRechargeCard = (card) => {
  isCustom.value = false
  selectedRechargeCard.value = card
}

// 监听对话框打开，默认选择最后一个卡片
watch(showRechargeDialog, (newVal) => {
  if (newVal) {
    getRechargeCards().then(() => {
      if (rechargeCards.value.length > 0) {
        selectedRechargeCard.value = rechargeCards.value[rechargeCards.value.length - 1]
        isCustom.value = false
      } else {
        // 如果没有套餐，默认选中自定义充值
        selectedRechargeCard.value = null
        isCustom.value = true
      }
    })
  }
})

// 监听自定义充值金额变化
watch(
  () => customAmount.value,
  (val) => {
    const num = Number(val)
    let t = num > 0 ? num * 9.9 : 0
    customAmount.price = t.toFixed(2)
  },
  { immediate: true }
)

// 确认充值
const handleRechargeConfirm = async () => {
  if (blockUnavailablePayment()) return
  // 如果有套餐，必须选择套餐
  if (rechargeCards.value.length > 0) {
    if (!selectedRechargeCard.value) {
      ElMessage.warning('请选择充值套餐')
      return
    }
  } else {
    // 如果没有套餐，必须使用自定义充值
    if (!isCustom.value || customAmount.value <= 0) {
      ElMessage.warning('请输入自定义充值金额')
      return
    }
  }
  try {
    const orderParams = {
      packageId: isCustom.value ? 0 : selectedRechargeCard.value.id,
      amount: isCustom.value ? customAmount.price : selectedRechargeCard.value.price,
      payType: rechargePayMethod.value,
      power: isCustom.value ? (customAmount.value * 10000) : selectedRechargeCard.value.actPower //自定义充值点数值的单位是万
    }
    const res = await createAgentPowerPoolOrder(orderParams)
    if (res.code !== 0 || !res.orderId) {
      ElMessage.error(res.message || '创建订单失败')
      return
    }
    currentOrderId.value = res.orderId
    if (rechargePayMethod.value === 'wechat') {
      const wxRes = await getWxPayParams(res.orderId)
      if (wxRes.code === 0 && wxRes.code_url) {
        payQRCode.value = await QRCode.toDataURL(wxRes.code_url, { width: 200 })
        showPayModal.value = true
        showRechargeDialog.value = false
        startPaymentPolling()
      } else {
        ElMessage.error(wxRes.msg || '获取微信二维码失败')
      }
    } else if (rechargePayMethod.value === 'alipay') {
      const aliRes = await getAlipayParams(res.orderId)
      const formHtml = aliRes.data?.qrCode || aliRes.msg
      if (aliRes.code === 0 && formHtml) {
        const tempDiv = document.createElement('div')
        tempDiv.id = 'alipay-temp-form-div'
        tempDiv.style.display = 'none'
        tempDiv.innerHTML = formHtml
        document.body.appendChild(tempDiv)
        const form = tempDiv.querySelector('form')
        if (form) {
          form.method = 'post'
          form.target = '_blank'
          form.submit()
          setTimeout(() => {
            if (tempDiv.parentNode) document.body.removeChild(tempDiv)
          }, 2000)
          showRechargeDialog.value = false
          startPaymentPolling()
        } else {
          ElMessage.error('支付宝表单异常')
        }
      } else {
        ElMessage.error(aliRes.message || '获取支付宝支付信息失败')
      }
    }
  } catch (error) {
    console.error('充值失败:', error)
    ElMessage.error(error.message || '充值失败')
  }
}

// 开始支付状态轮询
function startPaymentPolling() {
  stopPaymentPolling()
  paymentPollingTimer.value = setInterval(() => {
    checkPaymentStatus()
  }, 3000)
}

// 停止支付状态轮询
function stopPaymentPolling() {
  if (paymentPollingTimer.value) {
    clearInterval(paymentPollingTimer.value)
    paymentPollingTimer.value = null
  }
}

// 检查支付状态
async function checkPaymentStatus() {
  if (!currentOrderId.value) return
  try {
    let res
    if (rechargePayMethod.value === 'wechat') {
      res = await queryWxPayOrder(currentOrderId.value)
    } else {
      res = await queryAlipayOrder(currentOrderId.value)
    }
    if (res && res.code === 0 && res.data && res.data.status === 3) {
      // 支付成功
      stopPaymentPolling()
      showPayModal.value = false
      ElMessage.success('充值成功')
      // 刷新点数池余额
      await refreshUserInfo(true)
      // 刷新点数流水
      await getPowerLogList()
      currentOrderId.value = ''
    }
  } catch (error) {
    console.error('查询支付状态失败:', error)
  }
}

// 结算对账相关
const unsettledAmount = ref(0)
const withdrawList = ref([])
const withdrawPage = ref(1)
const withdrawLimit = ref(20)
const withdrawTotal = ref(0)

// 获取结算列表
const getWithdrawList = async () => {
  try {
    const res = await getCreditCalculationList({
      page: withdrawPage.value,
      limit: withdrawLimit.value
    })
    if (res.code === 0 && res.page) {
      // 映射后端字段到前端显示字段
      withdrawList.value = (res.page.list || []).map(item => ({
        withdrawDate: item.settlementDate || '',
        userRechargePowerSum: item.rechargeTotalPower || 0,
        poolDeductionSum: item.computingPowerDeduction || 0,
        poolOverflowSum: item.computingPowerEscape || 0,
        billAmount: item.rechargeTotalFree || 0,
        serviceFee: item.serviceFeeDeduction || 0,
        actualAmount: item.actualReceiptAmount || 0,
        status: item.status === 1 ? 'completed' : (item.status === 0 ? 'processing' : 'pending'),
        remark: item.remark || '',
        createDate: item.createDate || '',
        updateDate: item.updateDate || ''
      }))
      withdrawTotal.value = res.page.total || 0
    } else {
      withdrawList.value = []
      withdrawTotal.value = 0
      if (res.msg) {
        ElMessage.error(res.msg)
      }
    }
  } catch (error) {
    console.error('获取结算列表失败:', error)
    ElMessage.error('获取结算列表失败')
    withdrawList.value = []
    withdrawTotal.value = 0
  }
}

// 申请结算
const handleWithdraw = async () => {
  if (!unsettledAmount.value || unsettledAmount.value <= 0) {
    ElMessage.warning('未结算金额为0，无法申请结算')
    return
  }
  try {
    ElMessageBox.prompt('请输入结算金额', '申请结算', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /^\d+(\.\d{1,2})?$/,
      inputErrorMessage: '请输入正确的金额'
    }).then(async ({ value }) => {
      const amount = parseFloat(value)
      if (amount > unsettledAmount.value) {
        ElMessage.error('结算金额不能超过未结算金额')
        return
      }
      // await applyWithdraw({ amount })
      ElMessage.success('结算申请已提交')
      getWithdrawList()
      getSummaryData()
    }).catch(() => {})
  } catch (error) {
    ElMessage.error('申请结算失败')
  }
}

// 获取结算状态文本
const getWithdrawStatusText = (status) => {
  const statusMap = {
    pending: '待处理',
    processing: '结算中',
    completed: '已完成',
    failed: '失败'
  }
  return statusMap[status] || '未知'
}

// 获取结算状态标签类型
const getWithdrawStatusTagType = (status) => {
  const typeMap = {
    pending: 'warning',
    processing: 'info',
    completed: 'success',
    failed: 'danger'
  }
  return typeMap[status] || ''
}

// 结算分页
const handleWithdrawPageChange = (val) => {
  withdrawPage.value = val
  getWithdrawList()
}

const handleWithdrawSizeChange = (val) => {
  withdrawLimit.value = val
  withdrawPage.value = 1
  getWithdrawList()
}

// 点数转移相关
const showTransferDialog = ref(false)
const transferLoading = ref(false)
const subUserList = ref([])
const transferForm = ref({
  toUserId: '',
  power: 1000,
  remark: ''
})
const transferFormRef = ref()
const transferRules = {
  toUserId: [
    { required: true, message: '请选择接收用户', trigger: 'change' }
  ],
  power: [
    { required: true, message: '请输入转移点数数量', trigger: 'blur' },
    { type: 'number', min: 0.01, message: '转移点数必须大于0', trigger: 'blur' }
  ]
}

// 加载下级用户列表（包含自己）
const loadSubUserList = async () => {
  if (subUserList.value.length > 0) {
    return // 已经加载过，不再重复加载
  }
  try {
    const res = await getSubUserList()
    if (res && res.code === 0) {
      // 处理不同的返回格式
      const data = res.data || res
      subUserList.value = data.list || data || []
    } else {
      ElMessage.error(res?.msg || '获取用户列表失败')
    }
  } catch (error) {
    console.error('获取用户列表失败:', error)
    ElMessage.error('获取用户列表失败')
  }
}

// 监听对话框打开，加载用户列表
watch(showTransferDialog, (newVal) => {
  if (newVal) {
    // 重置表单
    transferForm.value = {
      toUserId: '',
      power: 1000,
      remark: ''
    }
    if (transferFormRef.value) {
      transferFormRef.value.clearValidate()
    }
    // 加载用户列表
    loadSubUserList()
  }
})

// 确认转移点数
const handleTransferConfirm = async () => {
  try {
    transferFormRef.value.validate(async (valid) => {
      if (!valid) {
        return false
      }
      
      // 检查转移点数是否超过可用点数
      const availablePower = parseFloat(summaryData.value.powerPoolBalance) || 0
      if (transferForm.value.power > availablePower) {
        ElMessage.error('转移点数不能超过可用点数池余额')
        return
      }
      
      if (transferForm.value.power <= 0) {
        ElMessage.error('转移点数必须大于0')
        return
      }
      
      transferLoading.value = true
      try {
        const res = await transferPowerPool({
          toUserId: transferForm.value.toUserId,
          power: transferForm.value.power,
          remark: transferForm.value.remark || '点数池转移'
        })
        
        if (res && res.code === 0) {
          ElMessage.success('点数转移成功')
          showTransferDialog.value = false
          // 刷新点数池余额
          await refreshUserInfo(true)
          // 刷新点数流水
          await getPowerLogList()
        } else {
          ElMessage.error(res?.msg || '点数转移失败')
        }
      } catch (error) {
        console.error('点数转移失败:', error)
        ElMessage.error('点数转移失败')
      } finally {
        transferLoading.value = false
      }
    })
  } catch (error) {
    console.error('表单验证失败:', error)
  }
}


// 初始化
onMounted(async () => {
  document.title = '代理中心'
  // 进入代理中心时，重新获取用户信息（会自动更新汇总数据和基础信息）
  try {
    await refreshUserInfo(true)
  } catch (error) {
    console.error('刷新用户信息失败:', error)
    // 如果刷新用户信息失败，仍然尝试获取汇总数据和基础信息
    try {
      await getSummaryData()
    } catch (error) {
      console.error('初始化汇总数据失败:', error)
    }
    try {
      await getBasicInfo()
    } catch (error) {
      console.error('初始化基础信息失败:', error)
    }
  }
  try {
    await getInviteCodeList()
  } catch (error) {
    console.error('初始化邀请码列表失败:', error)
  }
  try {
    await getPowerLogList()
  } catch (error) {
    console.error('初始化点数流水失败:', error)
  }
  try {
    await getWithdrawList()
  } catch (error) {
    console.error('初始化结算列表失败:', error)
  }
  try {
    await getRechargeCards()
  } catch (error) {
    console.error('获取充值套餐列表失败:', error)
  }
  unsettledAmount.value = summaryData.value.unsettledAmount
})

// 组件卸载时停止支付轮询
onUnmounted(() => {
  stopPaymentPolling()
})
</script>

<style scoped>
.agent-center {
  width: 100%;
  height: 100%;
  background: #F9FAFB;
  color: var(--text-primary);
  box-sizing: border-box;
  gap: 1px;
  display: flex;
  flex-direction: column;
}

/* 汇总信息区域 */
.summary-section {
  flex-shrink: 0;
  background: #fff;
  box-sizing: border-box;
  padding: 16px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.summary-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px 16px;
  background: #F9FAFB;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 0 1px #E5E7EB;
}

.summary-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(245, 158, 11, 0.3), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.summary-item:hover {
  border-color: var(--el-color-warning);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
  background: #fff;
}

.summary-item:hover::before {
  opacity: 1;
}

.summary-item.highlight-item {
  border-color: rgba(245, 158, 11, 0.3);
  background: linear-gradient(135deg, #fcf1c5 0%, #f9d79d 100%);
}

.summary-item.highlight-item::before {
  background: linear-gradient(90deg, transparent, rgba(245, 158, 11, 0.5), transparent);
  opacity: 0.5;
}

.summary-label {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 6px;
  font-weight: 500;
}

.summary-value {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.4;
}

.summary-value.highlight {
  color: var(--el-color-warning);
  font-size: 20px;
}

.highlight {
  color: var(--el-color-warning);
  font-weight: 600;
}

/* Tab内容区域（70%） */
.tabs-section {
  flex: 1;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  padding: 16px;
  box-sizing: border-box;
}

.tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}

:deep(.el-tabs) {
  display: flex;
  flex-direction: column;
  height: 100%;
}

:deep(.el-tabs__header) {
  flex-shrink: 0;
  margin-bottom: 16px;
  margin-top: 0;
  padding: 0;
  order: 1;
}

:deep(.el-tabs__nav-wrap) {
  margin-bottom: 0;
}

:deep(.el-tabs__content) {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  order: 2;
}

:deep(.el-tab-pane) {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tab-content {
  padding: 24px;
  min-height: 300px;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow-y: auto;
}

.form-width {
  max-width: 600px;
}

.image-uploader {
  width: 120px;
  height: 120px;
  border: 2px dashed #D1D5DB;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #F9FAFB;
  gap:4px;
}

.image-uploader:hover {
  border-color: var(--accent-blue);
  background: #EEF2FF;
}

.image-uploader2 {
  width: 250px;
  height: 340px;
  border: 2px dashed #D1D5DB;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #F9FAFB;
}

.image-uploader2:hover {
  border-color: var(--accent-blue);
  background: #EEF2FF;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.upload-icon {
  font-size: 24px;
  color: #666;
  margin-bottom: 2px;
}

.upload-text {
  color: #999;
  font-size: 12px;
}

.section-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  display: flex;
  text-align: center;
  align-items:baseline;
  font-size: 20px;
  font-weight: bold;
  color: var(--text-primary);
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-scroll-area {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

/* 结算对账样式 */
.withdraw-amount-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.withdraw-label {
  font-size: 14px;
  color: var(--text-secondary);
}

.withdraw-value {
  font-size: 20px;
  font-weight: 600;
  color: var(--el-color-warning);
}

/* Element Plus 样式覆盖 */
:deep(.el-tabs__item) {
  color: var(--text-secondary);
  font-size: 16px;
  padding: 0 20px;
}

:deep(.el-tabs__item:hover) {
  color: var(--el-color-primary);
}

:deep(.el-tabs__item.is-active) {
  color: var(--el-color-primary);
  font-weight: 600;
}

:deep(.el-tabs__active-bar) {
  background-color: var(--el-color-primary);
}

:deep(.el-tabs__nav-wrap::after) {
  background-color: #E5E7EB;
}

:deep(.el-table) {
  background: #fff;
  color: var(--text-primary);
}

:deep(.el-table th) {
  background: #F9FAFB;
  color: var(--text-primary);
  border-bottom: 1px solid #E5E7EB;
}

:deep(.el-table td) {
  border-bottom: 1px solid #E5E7EB;
}

:deep(.el-table--striped .el-table__body tr.el-table__row--striped td) {
  background: #F9FAFB;
}

:deep(.el-table tr) {
  background: #fff;
}

:deep(.el-table tr:hover > td) {
  background: #F3F4F6;
}

:deep(.el-input__inner) {
  background: #F9FAFB;
  border-color: #E5E7EB;
  color: var(--text-primary);
}

:deep(.el-input__inner:focus) {
  border-color: var(--accent-blue);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

:deep(.el-select .el-input__inner) {
  background: #F9FAFB;
  border-color: #E5E7EB;
  color: var(--text-primary);
}

:deep(.el-button--primary) {
  background: var(--el-color-warning);
  border-color: var(--el-color-warning);
  color: #fff;
}

:deep(.el-button--primary:hover) {
  background: #ffed4e;
  border-color: #ffed4e;
}

:deep(.el-pagination) {
  color: var(--text-primary);
}

:deep(.el-pagination .el-pager li) {
  background: #F9FAFB;
  color: var(--text-primary);
}

:deep(.el-pagination .el-pager li.is-active) {
  background: var(--el-color-warning);
  color: #fff;
}

:deep(.el-date-editor .el-input__inner) {
  background: #F9FAFB;
  border-color: #E5E7EB;
  color: var(--text-primary);
}

/* 点数池余额样式 */
.power-balance-row {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 16px;
  padding: 16px;
  background: #F9FAFB;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  gap: 16px;
}

.power-balance-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.power-balance-label {
  font-size: 14px;
  color: var(--text-secondary);
}

.power-balance-value {
  font-size: 20px;
  font-weight: 600;
  color: var(--el-color-warning);
}

/* 充值对话框样式 */
.recharge-content {
  padding: 8px 0;
}

.recharge-cards {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.recharge-card {
  position: relative;
  padding: 24px;
  background: #F9FAFB;
  border: 2px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  box-shadow: 0 0 0 1px #E5E7EB;
}

.recharge-card:hover {
  border-color: var(--el-color-warning);
  background: #fff7d9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
}

.recharge-card.selected {
  border-color: var(--el-color-warning);
  background: linear-gradient(135deg, #fcf1c5 0%, #f9d79d 100%);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2);
}

.recharge-discount-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 12px;
  color: #fff;
  font-weight: 600;
  padding: 4px 10px;
  background: linear-gradient(135deg, #67C23A 0%, #85ce61 100%);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.4);
  z-index: 1;
}

.recharge-power {
  font-size: 24px;
  font-weight: 600;
  color: var(--el-color-warning);
  margin-bottom: 12px;
}

.recharge-price {
  font-size: 20px;
  color: var(--text-primary);
  font-weight: 600;
}

.recharge-pay-method {
  display: flex;
  flex-direction: column;
}

.pay-method-label {
  font-size: 14px;
  color: var(--text-secondary);
}

:deep(.el-dialog) {
  background: #fff;
  border: 1px solid #E5E7EB;
}

:deep(.el-dialog__header) {
  background: #fff;
  border-bottom: 1px solid #E5E7EB;
  color: var(--text-primary);
}

:deep(.el-dialog__title) {
  color: var(--text-primary);
}

:deep(.el-dialog__body) {
  background: #fff;
  color: var(--text-primary);
}

:deep(.el-dialog__footer) {
  background: #fff;
  border-top: 1px solid #E5E7EB;
}

:deep(.el-radio) {
  color: var(--text-primary);
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  background-color: var(--el-color-warning);
  border-color: var(--el-color-warning);
}

:deep(.el-radio__label) {
  color: var(--text-primary);
}

/* 表格字段格式化样式 */
.text-muted {
  color: #999;
}

.text-danger {
  color: #F56C6C;
}

.text-highlight {
  font-weight: 500;
}

.text-success {
  color: #67C23A;
}

/* 点数转移对话框样式 */
.transfer-content {
  padding: 8px 0;
}

.transfer-info {
  padding: 16px;
  background: #F9FAFB;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
}

.transfer-info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.transfer-info-label {
  font-size: 14px;
  color: var(--text-secondary);
}

.transfer-info-value {
  font-size: 20px;
  font-weight: 600;
  color: var(--el-color-warning);
}

/* 支付对话框样式 */
.pay-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background: #fff;
}

.pay-order {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 16px;
}

.pay-qrcode {
  width: 200px;
  height: 200px;
  border: 1px solid #E5E7EB;
  background: #fff;
  border-radius: 8px;
}

.pay-info {
  font-size: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: var(--text-primary);
}

.pay-amount {
  font-weight: bold;
  margin-top: 8px;
}

.pay-amount-value {
  color: var(--el-color-warning);
  font-size: 22px;
}

.pay-tip {
  color: var(--text-secondary);
  font-size: 13px;
  margin-top: 12px;
  text-align: center;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 3px;
}
</style>
